'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'
import { safeAccess } from '../../utils/security'

export interface BirhausBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info'
  size?: 'sm' | 'md' | 'lg'
}

const variantClasses = {
  default: 'bg-gray-100 text-gray-800',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800', 
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800'
}

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base'
}

export function BirhausBadge({
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}: BirhausBadgeProps) {
  // Ensure variant and size are valid keys
  const validVariant = variant in variantClasses ? variant : 'default'
  const validSize = size in sizeClasses ? size : 'md'
  
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        safeAccess(variantClasses, validVariant, variantClasses.default),
        safeAccess(sizeClasses, validSize, sizeClasses.md),
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}